var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "18.851 16.862 162.15 162.149",
    viewBox: "18.851 16.862 162.15 162.149",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "tint",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.7 16.862c-44.776.124-80.974 36.524-80.849 81.3s36.524 80.974 81.3 80.849c44.774-.124 80.971-36.521 80.849-81.295-.173-44.757-36.543-80.927-81.3-80.854zm.426 156.15c-41.463.111-75.165-33.411-75.275-74.874s33.411-75.165 74.874-75.275c41.461-.111 75.162 33.409 75.275 74.869.067 41.444-33.427 75.121-74.871 75.28h-.003z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.553 80.153L99.782 45.715 85.2 80.234l-33.766.123 24.746 23.992-5.631 33.383 29.433-18.755 29.535 18.594-5.817-33.352 24.62-24.127-33.767.061zm6.734 45.147l-21.325-13.424-21.251 13.54 3.911-23.178L66.185 86.3l23-.084 10.64-25.186L110.6 86.16l23-.041-16.35 16.024 4.037 23.157z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e92080488fe40d021a97ddd5d5db2236.svg";
export { ForwardRef as ReactComponent };